/*******************************************************************************
 * Copyright (c) 2024-2026 Malond Limited. All rights reserved.
 * The source code is the property of Malond Limited.
 ******************************************************************************/

import { useAtomValue } from "jotai"
import { authLoadingAtom, isAuthenticatedAtom } from "../store/auth"

export function useAuthReady() {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  const authLoading = useAtomValue(authLoadingAtom)

  return {
    isAuthenticated,
    authLoading,
  }
}
